const FLAG_SRC = `/flags/v1`;

export const Flag = ({ countryCode }: { countryCode: string }) => {
  const code = countryCode.toUpperCase();
  return (
    <img
      height="14px"
      width="18px"
      loading="lazy"
      decoding="async"
      srcSet={`${FLAG_SRC}/2x/${code}.png 2x`}
      src={`${FLAG_SRC}/1x/${code}.png`}
      alt=""
    />
  );
};
